import { useMemo } from "react";
import {
  UseReflectionPersonalSummaryDataResult,
  UseReflectionPersonalSummaryDataArgs,
} from "./types";
import {
  filterEntriesForReflectionPersonalSummary,
  getReflectionEntryData,
} from "./utils";

export function useReflectionPersonalSummaryData({
  entries,
  sessionId,
}: UseReflectionPersonalSummaryDataArgs): UseReflectionPersonalSummaryDataResult {
  return useMemo(() => {
    const reflectionEntry = filterEntriesForReflectionPersonalSummary(
      entries,
      sessionId
    );

    return getReflectionEntryData(reflectionEntry[0]);
  }, [entries, sessionId]);
}
